import React from 'react'
import SignupContainer from 'views/SignupContainer'
import CompanyDetailsForm from 'shared/components/Forms/CompanyDetailsForm'

const CompanyDetails = () => {
  return (
    <SignupContainer>
      <CompanyDetailsForm/>
    </SignupContainer>
  )
}

export default CompanyDetails